import * as React from "react";

interface WritingPreviewViewProps {}

const WritingPreviewView: React.FC<WritingPreviewViewProps> = () => {
  return <p>Writing preview view</p>;
};

export default WritingPreviewView;
